function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("line", {
  x1: 7.92903,
  y1: 7.92891,
  x2: 22.0712,
  y2: 22.071,
  stroke: "black",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 22.0711,
  y1: 7.92892,
  x2: 7.92898,
  y2: 22.0711,
  stroke: "black",
  strokeWidth: 2
});

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjcuOTI5MDMiIHkxPSI3LjkyODkxIiB4Mj0iMjIuMDcxMiIgeTI9IjIyLjA3MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSIyMi4wNzExIiB5MT0iNy45Mjg5MiIgeDI9IjcuOTI4OTgiIHkyPSIyMi4wNzExIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgX as ReactComponent };